import Component from '@glimmer/component';
import { t } from 'ember-intl';
import importAsset from 'lumen/helpers/import-asset';
import type Highlight from 'lumen/models/roi-trophies/highlight';
import type { MarketLeaderData } from 'lumen/models/roi-trophies/highlight';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

import GeneralRoiTrophiesContentTrophyModalLayout from './trophy-modal-layout';

interface GeneralRoiTrophiesContentMarketLeaderSignature {
  Args: {
    highlight: Highlight;
  };
}

export default class GeneralRoiTrophiesContentMarketLeader extends Component<GeneralRoiTrophiesContentMarketLeaderSignature> {
  get data(): MarketLeaderData {
    return this.args.highlight.highlightData as MarketLeaderData;
  }

  <template>
    <GeneralRoiTrophiesContentTrophyModalLayout>
      <:content>
        <div class="flex flex-col items-center gap-300">
          <div class="heading-1">{{t "roi_trophies.market_leader.title"}}</div>
          <p
            class="text-300--regular text-neutral-subdued"
            data-test-id="market-leader-body"
          >
            {{#if this.data.is_first_time}}
              {{t "roi_trophies.market_leader.body_first_time"}}
            {{else}}
              {{t "roi_trophies.market_leader.body_ever_after"}}
            {{/if}}
          </p>
        </div>
      </:content>
      <:animation>
        <div
          {{lottieAnimation
            (importAsset "animations/roi-trophies/market-leader.json")
            false
          }}
        />
      </:animation>
    </GeneralRoiTrophiesContentTrophyModalLayout>
  </template>
}
